import React from 'react';
import { Link } from 'components';
import { ReactComponent as Car } from '../../../images/car.svg';
import { ReactComponent as PersonalLoan } from '../../../images/personal-loan.svg';
import { ReactComponent as Question } from '../../../images/qa.svg';

import * as styles from './styles.module.scss';

const CallToAction = ({ type, className, centerAlign }) => {
  const renderType = {
    'Sign up now': <SignUp centerAlign={centerAlign} />,
    'Finance Type': <FinanceType />,
    'Get Started': <GetStarted />,
    'Get a Quote': <GetQuote />,
  };

  return <div className={`${styles.callToAction} ${className || ''}`}>{renderType[type]}</div>;
};

const SignUp = ({ centerAlign }) => (
  <div className={`${styles.signUpCta} ${centerAlign ? styles.centerAlign : ''}`}>
    <Link to="https://dash.driva.co.nz/welcome" className={`button ${styles.button}`}>
      Sign up now
    </Link>
    <Link to="/faq" className={styles.ctaQuestion}>
      Have a question?
    </Link>
  </div>
);

const FinanceType = () => (
  <div className={styles.financeCta}>
    <div className={styles.textContainer}>
      <Question className={styles.question} />
      <span className={styles.text}>What type of finance are you after?</span>
    </div>
    <div className={styles.buttonsContainer}>
      {/* Vehicle */}
      <Link to="https://dash.driva.co.nz/welcome" className={styles.option}>
        <Car className={styles.optionIcon} />
        <span>Vehicle Loan</span>
      </Link>
      {/* Personal */}
      <Link to="https://dash.driva.co.nz/pl" className={styles.option}>
        <PersonalLoan className={styles.optionIcon} />
        <span>Personal Loan</span>
      </Link>
    </div>
  </div>
);

const GetStarted = () => (
  <Link to="https://dash.driva.co.nz/welcome" className={`button ${styles.button}`}>
    Get started
  </Link>
);

const GetQuote = () => (
  <a href="#" className={`button ${styles.button}`}>
    Get started
  </a>
);
export default CallToAction;
